$(function () {

    var linkBoxRow = $('.link_box_section__row');

    if (linkBoxRow.length < 1) {
        return;
    }

    linkBoxRow.align({
        selector: '> .link_box_section__column *'
    });

});